export default __webpack_public_path__ + "static/media/four.475aee69.png";